import React, { useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import DevelopmentBanner from './DevelopmentBanner'
import '../App.css'

function PrivacyPolicy() {
  useEffect(() => {
    // Stelle sicher, dass beim Mount die Seite oben ist
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <DevelopmentBanner />
      <Header />
      <div className="privacy-policy">
        <div className="container">
          <div className="privacy-content">
            <h1 className="privacy-title">Datenschutzerklärung</h1>
            <p className="privacy-last-updated">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

            <section className="privacy-section">
              <h2>1. Verantwortlicher</h2>
              <p>
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p>
                <strong>spotx</strong><br />
                E-Mail: kontakt@spotxapp.com
              </p>
            </section>

            <section className="privacy-section">
              <h2>2. Allgemeine Hinweise zur Datenverarbeitung</h2>
              <p>
                Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. 
                In dieser Datenschutzerklärung informieren wir Sie über die Verarbeitung 
                personenbezogener Daten bei der Nutzung unserer App und Website.
              </p>
            </section>

            <section className="privacy-section">
              <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
              
              <h3>3.1 Bei Besuch der Website</h3>
              <p>
                Beim Aufruf unserer Website werden durch den auf Ihrem Endgerät zum Einsatz 
                kommenden Browser automatisch Informationen an den Server unserer Website gesendet. 
                Diese Informationen werden temporär in einem sogenannten Logfile gespeichert. 
                Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur 
                automatisierten Löschung gespeichert:
              </p>
              <ul>
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
              </ul>
              <p>
                Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
              </p>
              <ul>
                <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
                <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
                <li>Auswertung der Systemsicherheit und -stabilität</li>
                <li>zu weiteren administrativen Zwecken</li>
              </ul>

              <h3>3.2 Bei Nutzung der App</h3>
              <p>
                Bei der Nutzung unserer App erheben und verarbeiten wir folgende Daten:
              </p>
              <ul>
                <li>Registrierungsdaten (E-Mail-Adresse, Benutzername)</li>
                <li>Nutzungsdaten (angesehene Kampagnen, Belohnungspunkte)</li>
                <li>Geräteinformationen (Gerätetyp, Betriebssystem, App-Version)</li>
                <li>Standortdaten (nur bei expliziter Einwilligung)</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>4. Weitergabe von Daten</h2>
              <p>
                Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im 
                Folgenden aufgeführten Zwecken findet nicht statt.
              </p>
              <p>
                Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
              </p>
              <ul>
                <li>Sie Ihre ausdrückliche Einwilligung dazu erteilt haben</li>
                <li>die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von 
                    Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, 
                    dass Sie ein überwiegendes schutzwürdiges Interesse an der Nichtweitergabe 
                    Ihrer Daten haben</li>
                <li>die Weitergabe zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist</li>
                <li>dies gesetzlich zulässig und für die Abwicklung von Vertragsverhältnissen 
                    mit Ihnen erforderlich ist</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>5. Cookies und Tracking-Technologien</h2>
              <p>
                Wir setzen auf unserer Website Cookies ein. Hierbei handelt es sich um kleine 
                Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät 
                (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Website besuchen.
              </p>
              <p>
                Cookies richten auf Ihrem Endgerät keinen Schaden an, enthalten keine Viren, 
                Trojaner oder sonstige Schadsoftware. In dem Cookie werden Informationen abgelegt, 
                die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben.
              </p>
              <p>
                Wir setzen Cookies ein, um die Nutzung unserer Website statistisch zu erfassen 
                und zum Zwecke der Optimierung unseres Angebotes auszuwerten. Diese Cookies 
                ermöglichen es uns, bei einem erneuten Besuch unserer Website automatisch zu 
                erkennen, dass Sie bereits bei uns waren.
              </p>
            </section>

            <section className="privacy-section">
              <h2>6. Ihre Rechte</h2>
              <p>Sie haben das Recht:</p>
              <ul>
                <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen 
                    Daten zu verlangen</li>
                <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder die 
                    Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen 
                    Daten zu verlangen</li>
                <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen 
                    Daten zu verlangen</li>
                <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem strukturierten, 
                    gängigen und maschinenlesbaren Format zu erhalten</li>
                <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber 
                    uns zu widerrufen</li>
                <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>7. Datensicherheit</h2>
              <p>
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure 
                Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die 
                von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 
                256 Bit Verschlüsselung. Falls Ihr Browser keine 256-Bit Verschlüsselung unterstützt, 
                greifen wir auf 128-Bit v3 Technologie zurück.
              </p>
              <p>
                Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, 
                erkennen Sie an der geschlossenen Darstellung des Schüssel- beziehungsweise 
                Schloss-Symbols in der unteren Statusleiste Ihres Browsers.
              </p>
              <p>
                Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer 
                Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, 
                teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff 
                Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen 
                Entwicklung fortlaufend verbessert.
              </p>
            </section>

            <section className="privacy-section">
              <h2>8. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}.
              </p>
              <p>
                Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund 
                geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig 
                werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung 
                kann jederzeit auf der Website unter dem Link "Datenschutz" von Ihnen abgerufen und 
                ausgedruckt werden.
              </p>
            </section>

            <section className="privacy-section">
              <h2>9. Kontakt</h2>
              <p>
                Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:
              </p>
              <p>
                <strong>spotx</strong><br />
                E-Mail: kontakt@spotxapp.com
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default PrivacyPolicy
